import styled from 'styled-components';
import { primary } from 'constants/color';

export const Wrapper = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: normal;
`;

export const SelectInput = styled.select`
  color: #333;
  font-size: 12px;
  padding: 3px 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #ccc;

  &:focus {
    outline: none;
    border: 1px solid ${primary};
  }
`;

export const FormGroup = styled.div`
  margin-left: 15px;
`;
